export const holdKey = [
  'reserved',
  'in_progress',
  'packed',
  'shipped',
  'received'
]

export const holdStylemap = {
  "reserved": {
    "backgroundColor":"#D3ECF6",
    "color":"#666666"
  },
  "in_progress": {
    "backgroundColor":"#E60073",
    "color":"white"

  },
  "packed": {
    "backgroundColor":"#c5982d",
    "color":"white"
  },
  "shipped": {
    "backgroundColor":"#3070E7",
    "color":"white"
  },
  "received": {
    "backgroundColor":"#40CC99",
    "color":"white"
  }
}

export const getStatusStyle = (status) => {
  if(holdStylemap[status]) {
    return holdStylemap[status]
  }
  return holdStylemap['reserved']
}

export function getReadableHoldStatus(hold) {
  if(hold && hold.status){
    //Captialize
    let status = (hold.status||"").charAt(0).toUpperCase() + hold.status.slice(1);
    return status.replaceAll("_", " ").replaceAll("-", " ")
  } else {
    console.error("No Hold or Incorrect Serialization of Hold for getReadableHoldStatus")
    return "";
  }
}

export function isHoldPacked(hold) {
  if(hold && hold.status){
    const packedIndex = holdKey.indexOf('packed');
    return holdKey.indexOf(hold.status) >= packedIndex
  }else {
    throw "No Hold or Incorrect Serialization of Hold for isPacked"
    return false;
  }
}

export function isHoldShipped(hold) {
  if(hold && hold.status){
    const packedIndex = holdKey.indexOf('shipped');
    return holdKey.indexOf(hold.status) >= packedIndex
  }else {
    throw "No Hold or Incorrect Serialization of Hold for isHoldShipped"
    return false;
  }
}

export function isHoldRecieved(hold) {
  if(hold && hold.status){
    const packedIndex = holdKey.indexOf('received');
    return holdKey.indexOf(hold.status) >= packedIndex
  }else {
    throw "No Hold or Incorrect Serialization of Hold for isHoldReceived"
    return false;
  }
}
